(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-blog"] && !Shopify.designMode) return;
  try {
    
(function(){
  var btns  = document.querySelectorAll('.bx-filter-btn');
  var cards = document.querySelectorAll('.bx-card');
  if(!btns.length||!cards.length)return;
  btns.forEach(function(btn){
    btn.addEventListener('click',function(){
      var filter=btn.getAttribute('data-filter');
      btns.forEach(function(b){b.classList.remove('active');b.setAttribute('aria-pressed','false');});
      btn.classList.add('active');btn.setAttribute('aria-pressed','true');
      cards.forEach(function(card){
        if(filter==='all'||card.getAttribute('data-category')===filter){
          card.classList.remove('bx-hidden');
        }else{
          card.classList.add('bx-hidden');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sqp-demo-compare"] && !Shopify.designMode) return;
  try {
    
  function sqpLoadHlsLibrary() {
    if (window.__sqpHlsPromise) return window.__sqpHlsPromise;

    window.__sqpHlsPromise = new Promise(function (resolve, reject) {
      if (window.Hls) {
        resolve(window.Hls);
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.13/hls.min.js';
      script.onload = function () {
        resolve(window.Hls);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__sqpHlsPromise;
  }

  function sqpDemoVideo(player) {
    return player.querySelector('video');
  }

  // Paint a real frame of the clip as the thumbnail.
  //
  // An .m3u8 source has nothing to show until hls.js has decoded a fragment,
  // which is why these players sat black: the <video> carried no src at all
  // until the first click. Priming attaches the source, lets through just
  // enough to render one frame, then stops loading again so the rest of the
  // clip still waits for a real play.
  function sqpPrimeThumbnail(player) {
    if (player.dataset.sqpPrimed === 'true') return;
    if (player.dataset.sqpAutoThumb !== 'true') return;
    if (player.dataset.sqpLoaded === 'true') return;

    var video = sqpDemoVideo(player);
    var src = player.dataset.sqpSrc;
    if (!video || !src) return;

    player.dataset.sqpPrimed = 'true';

    var seek = parseFloat(player.dataset.sqpFrame || '0') || 0;

    var settle = function () {
      // The opening frame of a clip is often black, so the still is taken a
      // little way in.
      if (seek > 0 && video.duration && seek < video.duration) {
        try { video.currentTime = seek; } catch (e) {}
      }
      if (player.__sqpHls && player.dataset.sqpLoaded !== 'true') {
        try { player.__sqpHls.stopLoad(); } catch (e) {}
      }
    };

    var needsHls = player.dataset.sqpHls === 'true';

    if (!needsHls || video.canPlayType('application/vnd.apple.mpegurl')) {
      video.preload = 'metadata';
      if (!video.getAttribute('src')) video.src = src;
      video.addEventListener('loadeddata', settle, { once: true });
      return;
    }

    sqpLoadHlsLibrary()
      .then(function (Hls) {
        if (!Hls || !Hls.isSupported()) return;
        var hls = new Hls();
        player.__sqpHls = hls;
        hls.loadSource(src);
        hls.attachMedia(video);
        video.addEventListener('loadeddata', settle, { once: true });
      })
      .catch(function () {});
  }

  function sqpPlayDemo(player) {
    var video = sqpDemoVideo(player);
    if (!video) return;

    var src = player.dataset.sqpSrc;
    var needsHls = player.dataset.sqpHls === 'true';

    var start = function () {
      player.classList.add('sqp-demo__player--playing');
      video.controls = true;
      // Priming may have parked the clip a fraction of a second in.
      if (video.currentTime && video.currentTime < 1) {
        try { video.currentTime = 0; } catch (e) {}
      }
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    };

    // Already streaming through hls.js from the thumbnail pass: resume the
    // loading that priming stopped rather than attaching a second source.
    if (player.__sqpHls) {
      player.dataset.sqpLoaded = 'true';
      try { player.__sqpHls.startLoad(); } catch (e) {}
      start();
      return;
    }

    if (src && !player.dataset.sqpLoaded) {
      player.dataset.sqpLoaded = 'true';

      if (!needsHls || video.canPlayType('application/vnd.apple.mpegurl')) {
        if (!video.getAttribute('src')) video.src = src;
        start();
        return;
      }

      sqpLoadHlsLibrary()
        .then(function (Hls) {
          if (Hls && Hls.isSupported()) {
            var hls = new Hls();
            player.__sqpHls = hls;
            hls.loadSource(src);
            hls.attachMedia(video);
          } else {
            video.src = src;
          }
          start();
        })
        .catch(function () {
          video.src = src;
          start();
        });
      return;
    }

    start();
  }

  function sqpInitDemoPlayers() {
    document.querySelectorAll('[data-sqp-demo-player]').forEach(function (player) {
      if (player.dataset.sqpBound === 'true') return;
      player.dataset.sqpBound = 'true';

      var overlay = player.querySelector('.sqp-demo__overlay');
      if (!overlay) return;

      // Declared before its first use. The auto-ratio branch below used to read
      // this while it was still hoisted-undefined, which threw and left every
      // play button in the section unbound.
      var video = sqpDemoVideo(player);

      // "Match the clip": the real ratio is only knowable once the browser has
      // the video's dimensions, so the CSS ratio is a placeholder until then.
      if (video && player.hasAttribute('data-sqp-demo-auto-ratio')) {
        video.addEventListener(
          'loadedmetadata',
          function () {
            if (video.videoWidth && video.videoHeight) {
              player.style.aspectRatio = video.videoWidth + ' / ' + video.videoHeight;
            }
          },
          { once: true }
        );
      }

      overlay.addEventListener('click', function () {
        sqpPlayDemo(player);
      });

      if (video) {
        video.addEventListener('pause', function () {
          if (video.currentTime === 0) player.classList.remove('sqp-demo__player--playing');
        });
      }

      // Fetch the thumbnail frame only once the clip is near the viewport, so
      // a visitor who never scrolls this far downloads none of it.
      if (player.dataset.sqpAutoThumb === 'true') {
        if (typeof IntersectionObserver === 'function') {
          var io = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                io.disconnect();
                sqpPrimeThumbnail(player);
              });
            },
            { rootMargin: '400px' }
          );
          io.observe(player);
        } else {
          sqpPrimeThumbnail(player);
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', sqpInitDemoPlayers);
  document.addEventListener('shopify:section:load', sqpInitDemoPlayers);
  sqpInitDemoPlayers();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sqp-people"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sqp-people__viewport--carousel').forEach(function (viewport) {
    var track = viewport.querySelector('[data-sqp-people-track]');
    var prev = viewport.querySelector('[data-sqp-people-prev]');
    var next = viewport.querySelector('[data-sqp-people-next]');
    if (!track) return;

    function page(direction) {
      var card = track.querySelector('.sqp-people__person');
      // A whole card plus its gap, so a click lands cleanly on the next snap
      // point rather than part way between two.
      var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  function sqpPeopleLoadHls() {
    if (window.__sqpHlsPromise) return window.__sqpHlsPromise;

    window.__sqpHlsPromise = new Promise(function (resolve, reject) {
      if (window.Hls) {
        resolve(window.Hls);
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.13/hls.min.js';
      script.onload = function () {
        resolve(window.Hls);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__sqpHlsPromise;
  }

  function sqpInitPeoplePlayers() {
    document.querySelectorAll('[data-sqp-person-player]').forEach(function (tile) {
      if (tile.dataset.sqpBound === 'true') return;
      tile.dataset.sqpBound = 'true';

      var button = tile.querySelector('.sqp-people__play-wrap');
      var video = tile.querySelector('video');
      if (!button || !video) return;

      button.addEventListener('click', function () {
        var src = tile.dataset.sqpSrc;
        var needsHls = tile.dataset.sqpHls === 'true';

        var start = function () {
          tile.classList.add('sqp-people__tile--playing');
          video.controls = true;
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {});
        };

        if (src && !tile.dataset.sqpLoaded) {
          tile.dataset.sqpLoaded = 'true';

          if (!needsHls || video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = src;
            start();
            return;
          }

          sqpPeopleLoadHls()
            .then(function (Hls) {
              if (Hls && Hls.isSupported()) {
                var hls = new Hls();
                hls.loadSource(src);
                hls.attachMedia(video);
              } else {
                video.src = src;
              }
              start();
            })
            .catch(function () {
              video.src = src;
              start();
            });
          return;
        }

        start();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', sqpInitPeoplePlayers);
  document.addEventListener('shopify:section:load', sqpInitPeoplePlayers);
  sqpInitPeoplePlayers();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sqp-reviews"] && !Shopify.designMode) return;
  try {
    
  function sqpInitReviewFilters() {
    document.querySelectorAll('[data-sqp-reviews]').forEach(function (root) {
      if (root.dataset.sqpBound === 'true') return;
      root.dataset.sqpBound = 'true';

      var pills = root.querySelectorAll('.sqp-rev__pill');
      var cards = root.querySelectorAll('.sqp-rev__card');
      var empty = root.querySelector('.sqp-rev__empty');
      if (!pills.length || !cards.length) return;

      var apply = function (filter) {
        var visible = 0;

        cards.forEach(function (card) {
          var tags = (card.dataset.sqpTags || '')
            .split(',')
            .map(function (tag) {
              return tag.trim();
            })
            .filter(Boolean);

          var show = !filter || tags.indexOf(filter) !== -1;
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (empty) empty.hidden = visible !== 0;
      };

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (other) {
            other.classList.toggle('sqp-rev__pill--on', other === pill);
          });
          apply(pill.dataset.sqpFilter || '');
        });
      });

      var initial = root.querySelector('.sqp-rev__pill--on');
      if (initial) apply(initial.dataset.sqpFilter || '');
    });
  }

  document.addEventListener('DOMContentLoaded', sqpInitReviewFilters);
  document.addEventListener('shopify:section:load', sqpInitReviewFilters);
  sqpInitReviewFilters();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sqp-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  class SqpStickyBar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.variants = {};
      const json = this.querySelector('[data-sqp-bar-variants]');
      if (json) {
        try {
          this.variants = JSON.parse(json.textContent);
        } catch (error) {
          this.variants = {};
        }
      }

      this.priceEl = this.querySelector('[data-sqp-bar-price]');
      this.compareEl = this.querySelector('[data-sqp-bar-compare]');
      this.badgeEl = this.querySelector('[data-sqp-bar-badge]');
      this.metaEl = this.querySelector('[data-sqp-bar-meta]');
      this.button = this.querySelector('[data-sqp-bar-add]');

      if (this.button) {
        this.button.addEventListener('click', () => {
          const target = this.targetButton();
          if (target) target.click();
        });
      }

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      document.addEventListener('variant:update', (event) => this.sync(event));
      document.addEventListener('variant:selected', () => {
        window.setTimeout(() => this.sync(), 60);
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    targetButton() {
      return document.querySelector('product-form-component [ref="addToCartButton"]') ||
        document.querySelector('.product-details [ref="addToCartButton"]') ||
        document.querySelector('.product-details button[name="add"]');
    }

    onScroll() {
      if (this.dataset.showOnLoad === 'true') {
        this.classList.add('sqp-bar--visible');
        return;
      }
      if (this.dataset.autoShow !== 'true') return;
      const trigger = parseInt(this.dataset.trigger || '600', 10);
      this.classList.toggle('sqp-bar--visible', window.scrollY > trigger);
    }

    currentVariantId(event) {
      const fromEvent = event && event.detail && event.detail.resource && event.detail.resource.id;
      if (fromEvent) return String(fromEvent);

      try {
        const fromUrl = new URL(window.location.href).searchParams.get('variant');
        if (fromUrl) return fromUrl;
      } catch (error) {
        // ignore
      }

      const checked = document.querySelector('variant-picker input:checked[data-variant-id]');
      return checked ? checked.dataset.variantId : this.dataset.variantId;
    }

    sync(event) {
      const id = this.currentVariantId(event);
      const data = this.variants[id];
      if (!data) return;

      this.dataset.variantId = id;
      if (this.priceEl) this.priceEl.textContent = data.price;

      if (this.compareEl) {
        this.compareEl.textContent = data.compare || '';
        this.compareEl.hidden = !data.compare;
      }

      if (this.badgeEl) {
        const prefix = this.badgeEl.dataset.prefix || this.dataset.badgePrefix || 'SAVE';
        this.badgeEl.textContent = data.save ? prefix + ' ' + data.save : '';
        this.badgeEl.hidden = !data.save;
      }

      if (this.metaEl && this.dataset.metaMode === 'variant') {
        const suffix = this.dataset.metaSuffix ? ' ' + this.dataset.metaSuffix : '';
        this.metaEl.textContent = data.title + suffix;
      }

      if (this.button) {
        this.button.disabled = !data.available;
        this.button.textContent = data.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }
    }
  }

  if (!customElements.get('sqp-sticky-bar')) {
    customElements.define('sqp-sticky-bar', SqpStickyBar);
  }

  } catch(e) { console.error(e); }
})();
})();
